import { useState, useEffect } from 'react'
import filter from 'lodash/filter'
import { useNavigate } from 'hooks'
import { casesMockTable } from 'mocks'
import {
  SearchBar,
  Button,
  TableLite,
  NewCaseButton,
  ImportFailureModal,
} from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { useErrorHandler } from 'hooks/utility/useErrorHandler'
import { useTranslation } from 'react-i18next'
import { getFuneralHomeCases } from '@/api/cases'

export const CasesTableLite = ({
  rowClick,
  setShowModal,
  height,
  type,
  importCase,
  refresh: [refreshCases, setRefresh] = ['', null],
}) => {
  const { t } = useTranslation()
  const handleError = useErrorHandler('CasesTableLite')
  const navigate = useNavigate()
  const [cases, setCases] = useState(casesMockTable)
  const [itemsLoaded, setItemsLoaded] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [csvFailed, setCsvFailed] = useState(false)

  const selectCase = (row) => {
    setShowModal(false)
    if (rowClick) {
      rowClick(row?.id)
    } else {
      navigate(`/package/${row?.id}`)
    }
  }

  const getCases = async () => {
    try {
      const {
        data: { cases },
      } = await getFuneralHomeCases(false)
      setCases(cases)
      setItemsLoaded(true)
    } catch (error) {
      handleError(error?.response?.data?.message || error.message, error)
    }
  }

  const filteredCases = () => {
    const filtered = filter(cases, (items) => {
      const include = (key) =>
        items?.[key]?.toLowerCase()?.includes(searchValue?.toLowerCase())
      return (
        include('id') ||
        include('editable_case_id') ||
        include('name_of_deceased')
      )
    })
    return searchValue === '' ? cases : filtered
  }

  useEffect(() => {
    if (refreshCases) {
      getCases()
      setRefresh((prev) => !prev)
    }
    // eslint-disable-next-line
  }, [refreshCases, setRefresh])

  useEffect(() => {
    getCases()
    // eslint-disable-next-line
  }, [])

  return (
    <Flex column width="700px" height={height || undefined}>
      <ImportFailureModal
        show={[csvFailed, setCsvFailed]}
        openFile={importCase}
      />

      <Flex background="paleSecondary" padding="32px" height="88px">
        <Text size="24px" weight="600">
          {t('newPrintPackage.title')}
        </Text>
      </Flex>
      <Flex column padding="32px 32px 12px 32px">
        <Flex margin="0 0 32px 0">
          <SearchBar
            placeholder={t('newPrintPackage.searchPlaceholder')}
            value={[searchValue, setSearchValue]}
            margin="0 16px 0 0"
            flex="1"
          />
          <Button
            icon="importCase"
            margin="0 16px 0 0"
            onClick={() => importCase()}
          >
            {t('newPrintPackage.importCase')}
          </Button>
          <NewCaseButton type={type} onSave={rowClick} />
        </Flex>
        <TableLite
          height="500px"
          data={filteredCases()}
          loaded={itemsLoaded}
          structure={[
            {
              title: t('newPrintPackage.table.case'),
              key: 'editable_case_id',
              secondKey: 'id',
              truncate: '13',
            },
            {
              title: t('newPrintPackage.table.deceasedName'),
              key: 'name_of_deceased',
            },
          ]}
          rowClick={selectCase}
        />
      </Flex>
    </Flex>
  )
}

export default CasesTableLite
